import { render, staticRenderFns } from "./InformacoesEmpresariais.vue?vue&type=template&id=67282fd5"
import script from "./InformacoesEmpresariais.vue?vue&type=script&lang=js"
export * from "./InformacoesEmpresariais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports